import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeatmap = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 4H9.2223V10.2223H3V4ZM10 7.8892H13.1108V10.2223H10V7.8892ZM13.8892 7.8892H17V10.2223H13.8892V7.8892ZM13.8892 4H17V7.1108H13.8892V4ZM10 4H13.1108V7.1108H10V4ZM3 11H9.2223V14.1108H3V11ZM10 11H17V14.1108H10V11ZM3 14.8892H9.2223V16.4446H3V14.8892ZM10 14.8892H17V16.4446H10V14.8892Z",
		fill: "#0D2976"
	})
});
export default SvgHeatmap;
